// GENERATED from shared/business-themes.json. Do not edit.
export const businessThemes = [
  {
    "value": "business-yellow-blue",
    "label": "Business Gelb-Blau",
    "hint": "Firmenblau, Sonnengelb und klare Arbeitsflächen"
  },
  {
    "value": "business-dark",
    "label": "Business Dunkel",
    "hint": "Neutrales Anthrazit mit klaren Kontrasten"
  },
  {
    "value": "business-blue",
    "label": "Business Blau",
    "hint": "Gedecktes Unternehmensblau auf ruhigen Flächen"
  }
] as const;
export type BusinessTheme = typeof businessThemes[number]["value"];
export const isBusinessTheme = (value: string | null): value is BusinessTheme => businessThemes.some(theme => theme.value === value);
export const normalizeBusinessTheme = (value: string | null): string | null => value === "business-light" ? "business-yellow-blue" : value;
